import { ReactNode, useLayoutEffect, useRef, useState } from "react"
import './animated-height.css'

// eases its height to whatever its children measure, so swapping content doesn't snap the layout
export const AnimatedHeight = ({ children, className = '' }: { children: ReactNode, className?: string }) => {
  const innerRef = useRef<HTMLDivElement>(null)
  const [height, setHeight] = useState<number | null>(null)

  useLayoutEffect(() => {
    const inner = innerRef.current
    if (!inner) return
    const updateHeight = () => setHeight(inner.offsetHeight)
    updateHeight()
    const resizeObserver = new ResizeObserver(updateHeight)
    resizeObserver.observe(inner)
    return () => resizeObserver.disconnect()
  }, [])

  return (
    <div className={`animated_height ${className}`} style={{ height: height ?? 'auto' }}>
      <div ref={innerRef} className="animated_height__inner">{children}</div>
    </div>
  )
}
